export function getHyperlinkFromField(field) {
  let fieldObj;

  if (typeof field === "string") {
    try {
      fieldObj = JSON.tryParse(field);
    } catch (error) {
      console.error("Error parsing JSON in getHyperlinkFromField:", error);
      throw new Error("Invalid JSON format in field");
    }
  } else if (typeof field === "object" && field !== null) {
    fieldObj = field;
  } else {
    throw new Error("Field must be either a JSON string or an object");
  }

  if (!fieldObj.href && !fieldObj.text) {
    throw new Error("Both 'href' and 'text' properties are missing in the field object");
  } else if (!fieldObj.href) {
    throw new Error("Missing 'href' property in the field object");
  } else if (!fieldObj.text) {
    throw new Error("Missing 'text' property in the field object");
  }

  return `<a href="${fieldObj.href}" target="_blank">${fieldObj.text}</a>`;
}
